import script from "./RealTimeTrade.vue?vue&type=script&setup=true&lang=js"
export * from "./RealTimeTrade.vue?vue&type=script&setup=true&lang=js"

import "./RealTimeTrade.vue?vue&type=style&index=0&id=0f10edf1&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f10edf1"]])

export default __exports__